export default __webpack_public_path__ + "static/media/element_38.58ff6ccb.webp";